import React from 'react';
import styled from 'styled-components';
import {
  SectionContainer,
  SectionTextContainer,
} from '../../../aboutUs/styles';
import { COLORS, device } from '../../../../constants';
import { Box, Title } from '../../../../components';
import { StepElement } from './StepElement';

interface DivProps extends React.HTMLProps<HTMLDivElement> {}

export const DevelopmentProcess: React.FC<DivProps> = ({ ...props }) => {
  const steps: string[] = [
    'Planning',
    'Daily meetings',
    'Demo',
    'Code review',
    'Grooming',
    'Retrospective',
  ];

  return (
    <SectionContainer color={COLORS.LIGHT_BG_COLOR}>
      <Box>
        <SectionTextContainer $gap={80}>
          <Title title="Development process" />
          <StepsContainer {...props}>
            {steps.map((step, index) => (
              <StepElement
                key={index}
                stepNr={`0${index + 1}`}
                stepText={step}
              />
            ))}
          </StepsContainer>
        </SectionTextContainer>
      </Box>
    </SectionContainer>
  );
};

const StepsContainer = styled.div`
  position: relative;
  max-width: 1407px;
  display: grid;
  grid-template-columns: repeat(6, minmax(130px, 185px));
  column-gap: 94px;
  row-gap: 48px;

  &::before {
    content: '';
    position: absolute;
    top: 48px;
    left: 0;
    right: 0;
    height: 1px;
    border-top: 3px dashed ${COLORS.STEP};
  }
  @media screen and ${device.xl} {
    grid-template-columns: repeat(6, 1fr);
    gap: 48px;
  }
  @media screen and ${device.xl} {
    gap: 20px;
  }
  @media screen and ${device.md} {
      &::before {
          top: 23px;
  }
  @media screen and ${device.sm} {
    display: flex;
    flex-direction: column;
    gap: 40px;
    &::before {
      top: 23px;
      left: 49px;
      bottom: 25px;
      width: 1px;
      height: auto;
      border-left: 3px dashed ${COLORS.STEP};
      border-top: none;
    }
  }
`;
